var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tab-pane fade",class:{ 'show active': _vm.isFirst },attrs:{"id":_vm.section.name + '_gui_body'}},[_c('row-component',{attrs:{"section":_vm.section}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }